import React, { ReactElement, ReactNode } from 'react';
import { Icon, AlyceTheme, IIconProps } from '@alycecom/ui';
import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles<AlyceTheme>(({ spacing }) => ({
  sectionIcon: {
    fontSize: 25,
    marginRight: spacing(1),
    marginBottom: 6,
  },
}));

interface IStepSectionProps {
  title: string;
  iconProps: IIconProps;
  children: ReactNode;
}

const StepSection = ({ title, iconProps, children }: IStepSectionProps): ReactElement => {
  const classes = useStyles();
  const margins = { xs: 2, md: 4 };
  return (
    <Box width={1} mt={margins}>
      <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" mb={2}>
        <Icon className={classes.sectionIcon} {...iconProps} />
        <Typography className="H3-Chambray">{title}</Typography>
      </Box>
      <Paper>
        <Box p={margins}>{children}</Box>
      </Paper>
    </Box>
  );
};

export default StepSection;
